import IdCardLanyardSvg from '@assets/images/svg/id-card-lanyard.svg';
import React from 'react';
import { View } from 'react-native';

export function IdCardLanyardIcon({ size = 24, color = '#333333' }: { size?: number; color?: string }) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <IdCardLanyardSvg width={size} height={size} color={color} />
        </View>
    );
}



